module.exports = __webpack_public_path__ + "img/6m.495531ee.png";